import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

/**
 * Resolves when i18next is fully initialized. Resources are bundled and
 * initImmediate is false, so init completes synchronously today — but the
 * first React render is gated on this promise (main.tsx) so a future move
 * to lazy-loaded translations can never reintroduce an untranslated first
 * paint.
 */
export const i18nReady: Promise<unknown> = i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: localStorage.getItem("weco-locale") ?? "en",
  fallbackLng: "en",
  initImmediate: false,
  interpolation: { escapeValue: false },
});

export default i18next;
